<template>
	<div id="app">
		<RegisterPayment v-if="planId" />
		<Register v-else />
	</div>
</template>

<script>
	import { mapState } from "vuex";
	import Register from "./views/Register";
	import RegisterPayment from "./views/RegisterPayment";

	export default {
		components: {
			Register,
			RegisterPayment
		},
		computed: {
			...mapState(["planId"])
		},
		async beforeCreate() {
			const branding = await this.$store.dispatch("branding");
			this.$store.commit("setIsLicensed", branding.is_licensed);
			this.$store.commit("setAccountManagerUrl", branding.account_manager);

			if (branding && branding.colors) {
				const root = document.documentElement;

				for (const [key, value] of Object.entries(branding.colors)) {
					root.style.setProperty(`--${key}`, value);
				}
			}
		}
	};
</script>
